import React from 'react';
import {
  Typography,
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

/**
 * Mirrors the members grid on the printed form (columns: No., Member Name,
 * Total Repaid, LSF, LSF C/F, Inst Paid, Loan C/F, Adva Paid, Int Paid,
 * Others, Adv C/F) plus a bold TOTALS row.
 */
const MembersTable = ({ members, totals, formatCurrency, isPastPeriod, navigating }) => {
  return (
    <>
      <Typography variant="h6" gutterBottom>
        Members Financial Performance
        {isPastPeriod && (
          <Typography
            component="span"
            variant="caption"
            sx={{
              ml: 2,
              px: 1,
              py: 0.25,
              bgcolor: 'info.light',
              borderRadius: 0.5,
              fontSize: '0.75rem'
            }}
          >
            Past Period - Auto-updated on navigation
          </Typography>
        )}
      </Typography>

      {members.length === 0 ? (
        <Alert severity="info" sx={{ mb: 4 }}>
          No performance data available for the selected period.
          {navigating && ' Updating period data...'}
        </Alert>
      ) : (
        <TableContainer component={Paper} sx={{ mb: 4, overflow: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                <TableCell>No.</TableCell>
                <TableCell>Member Name</TableCell>
                <TableCell align="right">Total Repaid</TableCell>
                <TableCell align="right">LSF</TableCell>
                <TableCell align="right">LSF C/F</TableCell>
                <TableCell align="right">Inst Paid</TableCell>
                <TableCell align="right">Loan C/F</TableCell>
                <TableCell align="right">Adva Paid</TableCell>
                <TableCell align="right">Int Paid</TableCell>
                <TableCell align="right">Others</TableCell>
                <TableCell align="right">Adv C/F</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {members.map((member, index) => (
                <TableRow key={member.id} hover>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{member.member_name}</TableCell>
                  <TableCell align="right">{formatCurrency(member.total_repaid)}</TableCell>
                  <TableCell align="right">{formatCurrency(member.lsf)}</TableCell>
                  <TableCell align="right">{formatCurrency(member.lsf_cf)}</TableCell>
                  <TableCell align="right">{formatCurrency(member.inst_paid)}</TableCell>
                  <TableCell align="right">{formatCurrency(member.loan_cf)}</TableCell>
                  <TableCell align="right">{formatCurrency(member.adv_paid)}</TableCell>
                  <TableCell align="right">{formatCurrency(member.int_paid)}</TableCell>
                  <TableCell align="right">{formatCurrency(member.others)}</TableCell>
                  <TableCell align="right">{formatCurrency(member.adv_cf)}</TableCell>
                </TableRow>
              ))}
              <TableRow sx={{ bgcolor: '#f5f5f5', fontWeight: 'bold' }}>
                <TableCell colSpan={2} sx={{ fontWeight: 'bold' }}>TOTALS</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totals.totalRepaid)}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totals.lsf)}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totals.lsfCF)}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totals.instPaid)}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totals.loanCF)}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totals.advaPaid)}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totals.intPaid)}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totals.others)}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totals.advCF)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default MembersTable;